import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

import {fetchList} from "../../hook/axios.hook";
import AvailabilityStatusCIrcule from "../../utilities/AvailabilityStatusCIrcule";
import {dateFormat, deadlineStatus} from "../../utilities/dateFormat";
import ReactTable from "../conteiners/ReactTable";

const RemindsList = () => {
  const {t} = useTranslation();

  const [todos, setTodos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchList("/todo/getAll", "get", {
          params: {isDeprecated: true},
        });
        setTodos(data || []);
      } catch (err) {
        console.error("Error fetching reminders:", err);
        setError(t("Failed to fetch deprecated todos"));
      }
    };

    fetchData();
  }, [t]);

  const isOutdated = todo => {
    if (todo.isDone) return false;
    return new Date(todo.dueDate) < new Date();
  };

  const columns = [
    {
      header: "№",
      accessorKey: "number",
      size: 40,
    },
    {
      header: t("Date"),
      accessorKey: "dueDate",
      size: 90,
    },
    {
      header: t("Project №"),
      accessorKey: "projectNumber",
      size: 90,
    },
    {
      header: t("CO №"),
      accessorKey: "coNumber",
      size: 90,
    },
    {
      header: t("Notes"),
      accessorKey: "note",
      size: 250,
      alignStart: true,
      enableColumnFilter: true,
      filterFn: "includesString",
    },
    {
      header: "D-day",
      accessorKey: "deadline",
      size: 90,
    },
    {
      header: t("Status"),
      accessorKey: "status",
      size: 70,
      cell: ({row}) => (
        <AvailabilityStatusCIrcule
          ifAvailable={row.original.isActual}
          tooltipMessage={row.original.isActual ? t("Actual") : t("Outdated")}
        />
      ),
    },
  ];

  const data = useMemo(
    () =>
      todos.map((todo, index) => {
        const outdated = isOutdated(todo);

        return {
          id: todo.todoId,
          number: index + 1,
          dueDate: dateFormat(todo.dueDate),
          projectNumber: todo.project?.projectNumber || "-",
          coNumber: todo.co?.coNumber || "-",
          note: todo.note,
          deadline: deadlineStatus(todo.dueDate),
          isActual: !outdated,
          status: !outdated,
        };
      }),
    [todos],
  );

  return (
    <div>
      <div className="project_list" style={{height: "260px", overflowY: "auto", fontSize: "11px", lineHeight: "12px"}}>
        {error && <div style={{color: "red"}}>{error}</div>}

        {!error && todos.length === 0 && <div>{t("No deprecated todos")}</div>}

        {!error && <ReactTable columns={columns} defaultData={data} selectable={false} />}
      </div>
    </div>
  );
};

export default RemindsList;
